module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.fa2772327f55d8198301.woff";


//////////////////
// WEBPACK FOOTER
// ./src/css/fonts/glyphicons-halflings-regular.woff
// module id = ./src/css/fonts/glyphicons-halflings-regular.woff
// module chunks = styles